import { render, staticRenderFns } from "./StatGroup.vue?vue&type=template&id=6af3bdde&scoped=true&"
import script from "./StatGroup.vue?vue&type=script&lang=js&"
export * from "./StatGroup.vue?vue&type=script&lang=js&"
import style0 from "./StatGroup.vue?vue&type=style&index=0&id=6af3bdde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af3bdde",
  null
  
)

export default component.exports